import { PageLayout } from '@7shifts/sous-chef';
import { __ } from 'i18n/translate';
import { Navigate, Outlet, Route, Routes, useParams } from 'react-router-dom';
import { useCompany } from 'adminPanel/modules/Companies/hooks/useCompany';
import CompanyOverviewPage from 'adminPanel/modules/Companies/pages/CompanyOverviewPage';
import CompanyUsersPage from 'adminPanel/modules/Companies/pages/CompanyUsersPage';
import CompanyQueuesPage from 'adminPanel/modules/Companies/pages/CompanyQueuesPage';
import CompanyChannelsPage from './CompanyChannelsPage';
import CompanyFeatureFlagsPage from './CompanyFeatureFlagsPage';
import CompanyTemplatesPage from './CompanyTemplatesPage';
import { useState } from 'react';
import { Company } from 'adminPanel/types';

const CompanyPage = () => {
    const { companyId } = useParams();
    const { company: fetchedCompany, isLoading } = useCompany(Number(companyId));
    const [company, setCompany] = useState<Company | null>(null);

    const resolved = company ?? fetchedCompany;

    if (isLoading || !resolved) {
        return null;
    }

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <PageLayout
                        title={resolved.name}
                        menu={[
                            {
                                name: 'overview',
                                label: __('adminpanel.overview'),
                                to: `/companies/${companyId}/overview`
                            },
                            {
                                name: 'users',
                                label: __('adminpanel.users'),
                                to: `/companies/${companyId}/users`
                            },
                            {
                                name: 'queues',
                                label: __('adminpanel.queues'),
                                to: `/companies/${companyId}/queues`
                            },
                            {
                                name: 'channels',
                                label: __('adminpanel.channels'),
                                to: `/companies/${companyId}/channels`
                            },
                            {
                                name: 'templates',
                                label: 'Templates',
                                to: `/companies/${companyId}/templates`
                            },
                            {
                                name: 'featureFlags',
                                label: __('adminpanel.featureFlags'),
                                to: `/companies/${companyId}/feature-flags`
                            }
                        ]}
                    >
                        <Outlet />
                    </PageLayout>
                }
            >
                <Route
                    path="overview"
                    element={
                        <CompanyOverviewPage
                            company={resolved}
                            onUpdate={setCompany}
                        />
                    }
                />
                <Route
                    path="users"
                    element={<CompanyUsersPage company={resolved} />}
                />
                <Route
                    path="queues"
                    element={<CompanyQueuesPage company={resolved} />}
                />
                <Route
                    path="channels"
                    element={<CompanyChannelsPage company={resolved} />}
                />
                <Route
                    path="templates"
                    element={<CompanyTemplatesPage company={resolved} />}
                />
                <Route
                    path="feature-flags"
                    element={<CompanyFeatureFlagsPage company={resolved} />}
                />
                <Route path="/" element={<Navigate to="overview" />} />
            </Route>
        </Routes>
    );
};

export default CompanyPage;
